<h2 mat-dialog-title>Dados do paciente</h2>

<mat-tab-group>
  <mat-tab label="Sobre">
    <div class="info">
      <div class="row">
        <div class="col-md-4 col-lg-2">Nome:</div>
        <div class="col-md-8 col-lg-10">{{ patient.name }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">Data de nascimento:</div>
        <div class="col-md-8 col-lg-10">{{ patient.birthDate || '-' | mask : '00/00/0000' }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">CPF:</div>
        <div class="col-md-8 col-lg-10">{{ patient.cpf || '-' | mask : '000.000.000-00' }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">Gênero:</div>
        <div class="col-md-8 col-lg-10">{{ patientGender }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">Telefone:</div>
        <div class="col-md-8 col-lg-10">{{ formatPhone(patient.phone) || '-' | mask : '(00) 00000-0000' }}</div>
      </div>
    </div>
  </mat-tab>

  <mat-tab *ngIf="address.cep != ''" label="Localização">
    <div class="info">
      <div class="row">
        <div class="col-md-4 col-lg-2">CEP:</div>
        <div class="col-md-8 col-lg-10">{{ address.cep | mask : '00000-000' }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">País:</div>
        <div class="col-md-8 col-lg-10">{{ address.country }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">Estado:</div>
        <div class="col-md-8 col-lg-10">{{ address.state }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">Cidade:</div>
        <div class="col-md-8 col-lg-10">{{ address.city }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">Lagradouro:</div>
        <div class="col-md-8 col-lg-10">{{ address.street }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-2">Número:</div>
        <div class="col-md-8 col-lg-10">{{ address.number }}</div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Histórico de consultas">
    <div>
      <p>Clique em um cartão abaixo para ver mais detalhes.</p>
      <ng-container *ngIf="pagedEncounters.length > 0; else noEncounters">
        <mat-card
          class="example-full-width previousEncountersCards"
          *ngFor="let encounter of pagedEncounters"
          (click)="openPatientPreviousEncounterDetail(encounter)"
        >
          {{ layout.dateFormat(encounter.startDate) }} - {{ encounter.name }}
        </mat-card>
      </ng-container>

      <div class="pagination-buttons">
        <button style="margin-right: 8px" mat-raised-button color="warn" mat-button (click)="prevPage()" [disabled]="currentPage === 1">
          Página anterior
        </button>
        <button mat-raised-button color="primary" mat-button (click)="nextPage()" [disabled]="currentPage === totalPages">Próxima página</button>
      </div>

      <ng-template #noEncounters>
        <p>Nenhum atendimento encontrado.</p>
      </ng-template>
    </div>
  </mat-tab>
</mat-tab-group>

<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>
